import React from 'react'
import Pt from 'prop-types'

import { BillingGroupRecord, ClientRecord } from '../../records'

export default function BillingGroupName({ billingGroup, client, separator = '-' }) {
  return (
    <span className="billing-group-name">
      {billingGroup.get('client_name_override') || client.get('name')}
      {billingGroup.get('name') !== 'Default' && (
        <span>
          {' '}{separator}{' '}
          {billingGroup.get('name')}
        </span>
      )}
    </span>
  )
}

BillingGroupName.propTypes = {
  billingGroup: Pt.instanceOf(BillingGroupRecord).isRequired,
  client: Pt.instanceOf(ClientRecord).isRequired,
  separator: Pt.node,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Client/BillingGroupName.jsx